// 红色主题资源路径
const redAssets = {
  loadingAnima:new URL("@/assets/loading.webp",import.meta.url).href,
  indexSearchBg:new URL("@/assets/images/bg_help.png",import.meta.url).href,
  indexSearchIcon:new URL("@/assets/images/icon_search_white.png",import.meta.url).href,
  logo:new URL("@/assets/images/logo2_red_ch.png",import.meta.url).href,
  logoHk:new URL("@/assets/images/logo2_red_hk.png",import.meta.url).href,
  headDefImg:new URL("@/assets/images/img_head_def.png",import.meta.url).href,
}

// 蓝色主题资源路径
const blueAssets = {
  loadingAnima:new URL("@/assets/theme-blue/loading.webp",import.meta.url).href,
  indexSearchBg:new URL("@/assets/theme-blue/images/bg_help.webp",import.meta.url).href,
  indexSearchIcon:new URL("@/assets/theme-blue/images/icon_search_gray.webp",import.meta.url).href,
  logo:new URL("@/assets/theme-blue/images/logo.webp",import.meta.url).href,
  logoHk:new URL("@/assets/theme-blue/images/logo_hk.webp",import.meta.url).href,
  headDefImg:new URL("@/assets/theme-blue/images/img_head_def.webp",import.meta.url).href,
}

const themeAssets = {
  red: redAssets,
  blue: blueAssets
}

export default themeAssets
